// src/Components/Broadcast/services/cacheService.js

class CacheService {
  constructor(ttl = 5 * 60 * 1000) { // 5 минут TTL по умолчанию
    this.cache = new Map();
    this.ttl = ttl;
  }

  set(key, data) {
    this.cache.set(key, {
      data,
      timestamp: Date.now()
    });
  }

  get(key = null) {
    // Если key не указан, возвращаем первый элемент (для совместимости)
    if (key === null) {
      const firstKey = this.cache.keys().next().value;
      if (!firstKey) return null;
      return this.get(firstKey);
    }
    
    const cached = this.cache.get(key);
    if (!cached) return null;
    
    // Проверяем TTL
    if (Date.now() - cached.timestamp > this.ttl) {
      this.cache.delete(key);
      return null;
    }
    
    return cached.data;
  }

  clear() {
    this.cache.clear();
  }

  remove(key) {
    this.cache.delete(key);
  }
}

// Создаем отдельные кэши для разных типов данных
export const usersCache = new CacheService(10 * 60 * 1000); // Пользователи на 10 минут
export const productsCache = new CacheService(30 * 60 * 1000); // Продукты на 30 минут
export const giftsCache = new CacheService(30 * 60 * 1000); // Подарки на 30 минут

// Функция для инвалидации кэша при изменениях
export const invalidateCache = () => {
  usersCache.clear();
  productsCache.clear();
  giftsCache.clear();
  console.log('Cache invalidated');
};